function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileText2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 36 44",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-text",
    preserveAspectRatio: "xMaxYMax",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 22 2 L 6 2 C 3.79 2 2 3.79 2 6 L 2 38 C 2 40.21 3.79 42 6 42 L 30 42 C 32.21 42 34 40.21 34 38 L 34 14 Z",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22 2 22 14 34 14",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 24,
    x2: 10,
    y2: 24,
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 32,
    x2: 10,
    y2: 32,
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 16 12 16 10 16",
    style: {
      stroke: "rgb(196, 196, 196)",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText2);
export default __webpack_public_path__ + "static/media/file-text-2.ff1b8a446662263c75921d5f26affd88.svg";
export { ForwardRef as ReactComponent };